import Identicon from 'identicon.js';
import { useMemo } from 'react';
export const Avatar = ({ address }: { address: string }) => {
  const data = useMemo(() => {
    const options = {
      foreground: [80, 26, 122, 255], // rgba black
      background: [255, 255, 255, 255], // rgba white
      margin: 0, // 20% margin
      size: 32, // 420px square
      format: 'svg' // use SVG instead of PNG
    };

    // create a base64 encoded SVG
    return new Identicon(address, options).toString();
  }, [address]);
  return (
    <div className="border-[1px] w-[48px] h-[48px] border-darkMatter-800 rounded-full flex justify-center items-center">
      <img src={`data:image/svg+xml;base64,${data}`} width={32} height={32} />
    </div>
  );
};
